import { P2GBox } from '@parcel2go/core-ui';
import { P2GButton } from '@parcel2go/core-ui';
import { P2GText } from '@parcel2go/core-ui';

import { useEffect } from 'react';
import { useState } from 'react';
import { ConsignmentParcelApiModel, SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { GenerateNumbers } from '../../../lib/helpers/ArrayHelper';
import { uid } from '../../../lib/helpers/uid';
import { SmartSendItemGroup } from '../item/SmartSendGroup';
import SidePanelSection from '../../../../../components/sidepanel-section';
import { GenerateQuantityConvertedSummary } from './GroupingHelper';
import { GroupingPanelParcels } from './GroupingPanelParcels';
import { QuantityValueSummary } from '../panels/QuantityValueSummary';
import { Trans, useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

export interface props {
  group: SmartSendItemGroup;
  split: (item: SmartSendItemApiModel, newItems: SmartSendItemApiModel[]) => void;
}

export const Convert: React.FC<props> = (props) => {
  const [parcels, setPacrels] = useState<ConsignmentParcelApiModel[]>([]);
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  function createSplitItems() {
    const summary = GenerateQuantityConvertedSummary(props.group);
    props.split(summary.item, summary.newItems);
  }

  const mainOl = props.group?.Items[0]?.MarketplaceOrderLines[0];

  useEffect(() => {
    const s = QuantityValueSummary(mainOl.Value, mainOl.Quantity);
    setPacrels(
      GenerateNumbers(1, Number(mainOl.Quantity)).map((x, i) => {
        const o: ConsignmentParcelApiModel = {
          Id: null,
          UID: uid(),
          Contents: [
            {
              ...mainOl,
              Quantity: 1,
              UID: uid(),
              Description: mainOl.Product.Description,
              Value: i == 0 ? s.valueForFirstItem : s.valueForOtherItems
            }
          ],
          CanAdd: false,
          Dimensions: {}
        };
        return o;
      })
    );
  }, [mainOl?.Quantity]);

  if (!mainOl) {
    return null;
  }

  const currencyCode = props.group.Items[0]?.CurrencyCode;

  return (
    <P2GBox>
      <P2GBox mb={3}>
        <P2GText>
          <Trans
            t={t}
            i18nKey="SPLIT_ITEM_INTRO_TEXT"
            values={{
              itemQuantity: mainOl.Quantity,
              currency: currencyCode,
              itemDescription: mainOl.Product.Description
            }}
            defaults={`This customer has ordered multiple '<strong>{{itemDescription}}</strong>'.
          <br /> Would you like to split these out in to {{itemQuantity}} separate shipments?`}
          />
        </P2GText>
      </P2GBox>
      <P2GBox>
        <SidePanelSection title={t('SHIPMENT_SUMMARY_SUBTITLE', { defaultValue: 'Shipment Summary' })}>
          <GroupingPanelParcels key={`parcels_${parcels.length}`} parcels={parcels} currencyCode={currencyCode} />
        </SidePanelSection>
      </P2GBox>
      <P2GBox mt={2}>
        <P2GButton onClick={createSplitItems}>
          {t('CONFIRM_CREATE_BUTTON', { defaultValue: 'Confirm and Create' })}
        </P2GButton>
      </P2GBox>
    </P2GBox>
  );
};
